export default {
  dbi_benchmark_mobile_game_benchmark: '手游Gaas分析',
  dbi_benchmark_game_gacha: '抽卡',
  dbi_benchmark_game_casual: '休闲',
  dbi_benchmark_game_shooter: '射击',
  dbi_benchmark_game_sports: '运动',
  dbi_benchmark_game_slg: '战争策略',
  dbi_benchmark_game_mmo: '大型多人在线',
  dbi_benchmark_game_top: '畅销',
  dbi_benchmark_tops_info: '该列表选取了在过去五年中表现较好的部分游戏，如果您对该列表任何反馈或疑问，请随时联系 @zhaofengliu。',
  dbi_benchmark_trends_kpi_data: 'KPI数据趋势',
  dbi_benchmark_regional_distribution_revenue: 'Regional Distribution of Revenue',
  dbi_benchmark_avg_dau: '日活用户平均值',
  dbi_benchmark_kpi_data: 'KPI数据',
  dbi_benchmark_ral: '留存,日活ARPU,LTV',
  dbi_benchmark_retention_curve: '留存率曲线',
  dbi_benchmark_original: '原始时间线',
  dbi_benchmark_aligned_across_apps: '按版本对齐',
  dbi_benchmark_reorder_base: '据算法重排',
  dbi_benchmark_time_period: '时间粒度',
  dbi_benchmark_m1_m12: 'M1～M12',
  dbi_benchmark_y1_y5: 'Y1～Y5',
  dbi_benchmark_system: 'System',
  dbi_benchmark_summary_kpi_data: 'KPI数据总结',
  dbi_benchmark_both: '全部',
  dbi_benchmark_ios: 'App Store',
  dbi_benchmark_android: 'Google Play',
  dbi_benchmark_ratios_by_region: '分区域关键比率',
  dbi_benchmark_system_demographics: '系统及用户画像',
  dbi_benchmark_game_level: '游戏级别',
  dbi_benchmark_overall: '聚合数据',
  dbi_benchmark_device: 'Device',
  dbi_benchmark_stream_source: '直播源',
  dbi_benchmark_time_scale: '时间跨度',
  dbi_benchmark_twitch: 'Twitch',
  dbi_benchmark_youtube: 'Youtube',
  dbi_benchmark_facebook: 'Facebook',
  dbi_benchmark_lifetime: '全生命周期',
  dbi_benchmark_365d: '近365天',
  dbi_benchmark_30d: '近30天',
  dbi_benchmark_ltv_365: 'LTV365',
  dbi_benchmark_relative: '相对CPI',
  dbi_benchmark_register: '注册率',
  dbi_benchmark_earliest_date_mobile: '最早日期',
  dbi_benchmark_regional_distribution: '分区域{type}分布',
  dbi_benchmark_avg_appStore_rating: '苹果商店平均评分',
  dbi_benchmark_avg_googleplay_rating: '谷歌商店平均评分',
  dbi_benchmark_db_earliest_date: '最早数据日期',
  dbi_benchmark_db_release_date: '发行日期',
  dbi_benchmark_no_data_yet: '暂无数据',

  dbi_benchmark_group_exists: '{type}分组已存在',
  dbi_benchmark_group_exists_qus: '所选游戏已关注，是否创建该分组副本？',

  dbi_benchmark_revenue_trend: '收入（美元）',
  dbi_benchmark_download_trend: '下载',
  dbi_benchmark_dau_trend: '日活用户平均值',
  dbi_benchmark_revenue_mobile: '收入',
  dbi_benchmark_download_mobile: '下载',
  dbi_benchmark_dau_mobile: '日活用户平均值',
  dbi_benchmark_revenue_mobile_lower: '收入',
  dbi_benchmark_download_mobile_lower: '下载',
  dbi_benchmark_dau_mobile_lower: '日活',
  dbi_benchmark_revenue_mobile_calc: '各年平均收入 = 总收入 / 游戏数量',
  dbi_benchmark_download_mobile_calc: '各年平均下载数 = 总下载数 / 游戏数量',
  dbi_benchmark_dau_mobile_calc: '各年平均日活 = 总平均每日活跃用户数 / 游戏数量',
  'dbi_benchmark_1y~5y_info': '五年内',
  'dbi_benchmark_1m~12m_info': '十二个月内',
  dbi_benchmark_reorder_base_info: '考虑到不同游戏的KPI数据的趋势各异，为使展示的趋势更加显著，数据科学家利用算法在时间维度上对各游戏的API数据进行了重排。算法以流水为参考，动态捕捉流水最大的十二个月作为重排后的首年，并基于重排后的首年逐步向外扩展出次年至第五年。',
  dbi_benchmark_trends_kpi_data_info: '这里显示的是自发行日后{type}KPI数据的平均趋势。详细游戏数据请参见页面顶部的 "统计：KPI数据"中。',
  dbi_benchmark_retention_curve_mobile_info: '这里展示了当前类目下各级别（S/A/B/C）游戏的平均留存情况。',
  dbi_benchmark_retention_curve_mobile_info_6: '这里展示了所选各游戏的留存情况',
  dbi_benchmark_regional_distribution_revenue_info: '每个区域的平均{type}：',
  dbi_benchmark_regional_distribution_revenue_calc: `各区域在总平均收入中的占率`,
  dbi_benchmark_regional_distribution_download_calc: `各区域在总平均下载次数的占率`,
  dbi_benchmark_regional_distribution_dau_calc: `各区域在平均日活的平均数值的占率`,
  dbi_benchmark_bar_trend_info: '每款游戏的平均{type}：',
  dbi_benchmark_mobile_gass_capability_info_x: 'x轴：发行首年用户平均游玩天数',
  dbi_benchmark_mobile_gass_capability_info_y: `y轴：发行首年平均日活ARPU`,
  dbi_benchmark_system_demographics_info: '这里展示的系统分布是根据各游戏的下载量加权平均得到的。展示的用户画像是所选品类的性别细分及年龄细分，若选择了‘TOPs’或‘Customized’，则会显示平均后的画像细分。',
  dbi_benchmark_ratios_by_region_info: `这里展示了各个区域中的LTV365、相对CPI、注册率等关键比率。其中LTV365是根据'GaaS Capability'中各游戏的留存及日活ARPU数据计算所得，相对CPI和注册率则是根据部分真实数据校准后得到。`,
  dbi_benchmark_retention: '留存',
  dbi_benchmark_system_device: '设备',
  dbi_benchmark_system_device_up: '设备',
  dbi_benchmark_mobile_average_days: '平均天数',
  dbi_benchmark_mobile_arpudau_curve: 'GaaS 能力：日活ARPU和留存率',
  dbi_benchmark_mobile_arpdau: '日活ARPU',
  dbi_benchmark_mobile_data_ai_info: '提供各游戏在全球范围的KPI指标数据，如流水、下载、活跃用户等',
  dbi_benchmark_google_app_info: '提供各游戏在商店中的用户评分',
  dbi_benchmark_mobile_tyf_info: '提供各游戏在相应平台的CCV、直播时长和观看时长等指标',
  dbi_benchmark_average_play_days: '发行首年用户平均游玩天数',
  dbi_benchmark_total: '总量',
  dbi_benchmark_source_info: '{type}数据来源于',
  dbi_benchmark_table_revenue_lower: '收入',
  dbi_benchmark_table_download_lower: '下载',
  dbi_benchmark_table_dau_lower: '日活用户平均值',
  dbi_benchmark_databrain: '数据大脑',
  dbi_benchmark_introduce_mobile: '这些指标是根据data.ai的数据总结得到。如需了解更多信息，请随时联系@zhaofengliu。',
  dbi_benchmark_tier: '{tier}级',

}